var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"value":_vm.value,"disabled":_vm.disabled,"clearable":_vm.clearable,"filterable":"","placeholder":"请选择币种"},on:{"input":function($event){return _vm.$emit('input', $event)}}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }